import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { v4 as uuid } from "uuid";
import { Autocomplete, theme, color as colors } from "@workboard/wobo-ui";
import { getOwner } from "../../services/organization";
import Template from "./Template";
import { useTranslation } from "react-i18next";

const Title = styled("h1")``;
const Label = styled("span")``;

const id = uuid();

const OwnerSelector = ({ className, onChange = () => {} }) => {
  const mountedRef = useRef(true);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation()
  useEffect(() => {
    async function fetchOwner() {
      const response = await getOwner();
      if (!mountedRef.current) return null;

      let defaultUser = {};
      if (response.users && response.defaultUserId) {
        const filteredUsers = response.users.filter(item => item.id === response.defaultUserId);
        if (filteredUsers.length !== 1) {
          console.log('Org Engagement: Invalid defaultUserId', response);
        } else {
          defaultUser = filteredUsers[0];
        }
      }

      setOptions({ users: response.users, def_user: defaultUser, curr_user: defaultUser });
    }

    fetchOwner();
  }, [setOptions]);

  useEffect(() => {
    if (options.curr_user) {
      onChange(options.curr_user);
    }
  }, [options, onChange]);

  const handleChange = useCallback(
    (ev, value) => {
      if (value) {
        setOptions({ ...options, curr_user: value });
        onChange(value);
      }
    },
    [options, onChange, setOptions]
  );

  return (
    <header className={className}>
      <Title>{t('Teams')}</Title>
      <Label id={id}>{t('Showing organization under')}</Label>
      <Autocomplete
        key={options}
        options={options.users ? options.users : []}
        template={Template}
        getOptionLabel={({ label }) => label ? label : ''}
        defaultValue={options.def_user ? options.def_user : {}}
        startMatch={false}
        rootProps={{
          'aria-labelledby': id,
          'data-testid': 'autocomplete-show-org-under'
        }}
        onChange={handleChange}
      />
    </header>
  );
};

export default styled(OwnerSelector)`
	align-items: center;
	display: flex;
	padding: 22px 24px;

	${Title} {
		margin: 0 18px 5px 0;
		color: ${colors("--black-opacity-84")};
		font-size: 20px;
		font-weight: bold;
	}

	${Label} {
		${theme("--font-normal")}
		color: ${colors("--black-opacity-84")};
		margin-right: 8px;
	}

	${Autocomplete} {
		width: 250px;
    z-index: 2;
	}
`;
